import React from "react";
import { FaBell, FaRegBell } from "react-icons/fa";
import Button from "../../../components/Button/Button";
import Loader from "../../../components/Loader/Loader";
import { useStudentNotifications } from "./hooks/useStudentNotifications";
import "./StudentNotifications.css";

const isUnread = (notification) => {
  if (typeof notification?.is_read !== "undefined") return !notification.is_read;
  if (typeof notification?.read_at !== "undefined") return !notification.read_at;
  if (typeof notification?.status !== "undefined") {
    return String(notification.status).toLowerCase() !== "read";
  }
  return false;
};

const getTitle = (notification) =>
  notification?.title || notification?.subject || notification?.heading || "Notification";

const getMessage = (notification) =>
  notification?.message || notification?.body || notification?.description || "";

const getTimestamp = (notification) =>
  notification?.created_at || notification?.date || notification?.timestamp || "";

const StudentNotifications = () => {
  const { notifications, isLoading, isMarking, markAllRead } = useStudentNotifications();

  if (isLoading) {
    return <Loader />;
  }

  const hasUnread = notifications.some(isUnread);

  return (
    <div className="sp-notifications-page">
      <div className="sp-notifications-header">
        <h2 className="sp-section-title" style={{ marginBottom: 0 }}>
          Notifications
        </h2>
        <Button
          variant="primary"
          onClick={markAllRead}
          loading={isMarking}
          disabled={!hasUnread || notifications.length === 0}
        >
          Mark all as read
        </Button>
      </div>

      {notifications.length === 0 ? (
        <div className="sp-card sp-empty-state sp-notifications-empty">
          <FaRegBell size={28} />
          <p className="mb-0">No notifications yet.</p>
        </div>
      ) : (
        <div className="sp-notifications-list">
          {notifications.map((notification, index) => {
            const unread = isUnread(notification);
            const timestamp = getTimestamp(notification);
            return (
              <div
                className={`sp-card sp-notification-row${unread ? " is-unread" : " is-read"}`}
                data-tone={unread ? "primary" : "secondary"}
                key={notification.id ?? index}
              >
                <span className="sp-icon-tile sp-notification-icon" aria-hidden="true">
                  {unread ? <FaBell /> : <FaRegBell />}
                </span>
                <div className="sp-notification-body">
                  <p className={`sp-notification-title${unread ? " is-unread" : ""}`}>
                    {unread && <span className="sp-notification-dot" aria-hidden="true" />}
                    {getTitle(notification)}
                  </p>
                  {getMessage(notification) && (
                    <p className="sp-notification-message">{getMessage(notification)}</p>
                  )}
                </div>
                {timestamp && (
                  <span className="sp-notification-time">
                    {new Date(timestamp).toString() !== "Invalid Date"
                      ? new Date(timestamp).toLocaleString()
                      : timestamp}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StudentNotifications;
